export default __webpack_public_path__ + "static/media/vuetify.20db9524.svg";